import { createContext, useEffect, useMemo, useState } from "react";
import "../Calendar.css";
import "../DatePicker.css";
import "../Selector.css";

import appStyles from "../App.module.css";
import Steps from "./components/Step";
import CGQuoteApi from "./components/api/CGQuoteApi";
import { useBreakpointClass } from "./components/page/BreakPointClass";
import cgConstants from "./config/cgConstants";
import { ICorporateGroupTravelContext, ICorporateInitialQuote } from "./config/interfaces";

const initialQuote: ICorporateInitialQuote = {
  hostCountry: "US",
  currency: "USD",
  companyLocation: null,
  startDate: null,
  endDate: null,
  destinationCountries: null,
  numberOfTravellers: 0,
  productId: cgConstants.CGProductId,
  affiliateId: cgConstants?.CGAffiliatedId,
  applicants: [
    {
      is_main: true,
      age: 35,
      trip_cost: 5000,
    },
  ],
};

export const CorporateGroupTravelContext = createContext<ICorporateGroupTravelContext | null>(null);

const CorporateGroupTravel = ({ version }: any) => {
  const bpClass = useBreakpointClass();
  const totalSteps = 4;
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [quoteData, setQuoteData] = useState<ICorporateInitialQuote>(initialQuote);
  const [loader, setLoader] = useState<boolean>(false);
  const [order, setOrder] = useState<any>(null);
  const [quoteResult, setQuoteResult] = useState<any>(null);
  const [destinationCountriesList, setDestinationCountries] = useState<any>(null);
  const [hasError, setHasError] = useState<string | null>(null);

  useEffect(() => {
    const init = async () => {
      try {
        const _quoteData: ICorporateInitialQuote = { ...quoteData };
        const queryString = window.location.search;
        // affiliated values always available either user pass or not
        _quoteData.affiliateId = new URLSearchParams(queryString).get("partner") || cgConstants.CGAffiliatedId;
        _quoteData.hostCountry = version;
        setQuoteData(_quoteData);

        const { data } = await CGQuoteApi.getDestinations();
        const filteredCountries = data
          ?.filter((country: any) => !country.is_disabled)
          ?.sort((a: any, b: any) => a.name.localeCompare(b.name));
        setDestinationCountries(filteredCountries);
      } catch (error) {
        console.log(error);
      }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  const contextValue = useMemo(
    () => ({
      totalSteps,
      currentStep,
      quoteData,
      setQuoteData,
      destinationCountriesList,
      loader,
      setLoader,
      order,
      setOrder,
      setQuoteResult,
      quoteResult,
      hasError,
      setHasError,
      next: () => {
        if (currentStep < totalSteps) {
          setCurrentStep(currentStep + 1);
        }
      },
      previous: () => {
        if (currentStep > 0) {
          setCurrentStep(currentStep - 1);
        }
      },
    }),
    [currentStep, quoteData, loader, order, quoteResult, destinationCountriesList, hasError]
  );

  return (
    <div className={`${appStyles.battlefacePlugin} ${bpClass}`}>
      <CorporateGroupTravelContext.Provider value={contextValue}>
        <Steps />
      </CorporateGroupTravelContext.Provider>
    </div>
  );
};

export default CorporateGroupTravel;
